export default __webpack_public_path__ + "static/media/Abstain.63392e18.svg";